import { render } from "./ca-privacy.vue?vue&type=template&id=2c6b62b2"
import script from "./ca-privacy.js?vue&type=script&lang=js"
export * from "./ca-privacy.js?vue&type=script&lang=js"

import "./ca-privacy.vue?vue&type=style&index=0&id=2c6b62b2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__